import { supabase } from "@/lib/supabase";

export interface EventComment {
  id: string;
  event_id: string;
  user_id: string;
  group_id: string;
  content: string;
  created_at: string;
}

export async function fetchEventComments(eventId: string): Promise<EventComment[]> {
  const { data, error } = await supabase
    .from("event_comments")
    .select("id, event_id, user_id, group_id, content, created_at")
    .eq("event_id", eventId)
    .order("created_at", { ascending: true });

  if (error) throw error;
  return data ?? [];
}

export async function addEventComment(
  eventId: string,
  groupId: string,
  userId: string,
  content: string
): Promise<EventComment> {
  const trimmed = content.trim();
  if (!trimmed) throw new Error("EMPTY_COMMENT");

  const { data, error } = await supabase
    .from("event_comments")
    .insert({
      event_id: eventId,
      group_id: groupId,
      user_id: userId,
      content: trimmed,
    })
    .select("id, event_id, user_id, group_id, content, created_at")
    .single();

  if (error) throw error;
  return data;
}

export async function deleteEventComment(commentId: string): Promise<void> {
  const { error } = await supabase.from("event_comments").delete().eq("id", commentId);
  if (error) throw error;
}
